import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { CandidateListContainerContent } from './CandidateListContainerContent';
import type { CandidateListContainerProps } from './types';

export function CandidateListContainer(props: CandidateListContainerProps) {
  return (
    <QueryErrorBoundary>
      <CandidateListContainerContent {...props} />
    </QueryErrorBoundary>
  );
}
